// extracted by mini-css-extract-plugin
export default {"installStatus":"InstallStatus--installStatus--cd6101","spinner":"InstallStatus--spinner--4ba86b","description":"InstallStatus--description--cc11b5"};